import { useRepositoryFeature } from "src/app/features/repositories/repositories.feature";
import {
  Brand,
  BrandAssetsInput,
  BrandAssetsResponse,
  IntegrationsAssets,
} from "src/graphql/client";

type updateBrandAssetsInput = {
  assets: BrandAssetsInput;
  brandId: string;
};

export interface AssetsRepository {
  getBusinessAccountAssets(): Promise<BrandAssetsResponse>;
  getBrandAssets(brandId: string): Promise<IntegrationsAssets>;
  updateBrandAssets(args: updateBrandAssetsInput): Promise<boolean>;
}

export const useAssetsDomain = (repo = "AssetsRepository") => {
  const { repository } = useRepositoryFeature<AssetsRepository>(repo);

  const getBusinessAccountAssets = async () => {
    return repository.getBusinessAccountAssets();
  };

  const getBrandAssets = async (brand: Brand) => {
    return repository.getBrandAssets(brand.id);
  };

  const updateBrandAssets = async (args: updateBrandAssetsInput) => {
    return repository.updateBrandAssets(args);
  };

  return {
    getBusinessAccountAssets,
    getBrandAssets,
    updateBrandAssets,
  };
};
